import {
  MARKER_LOST_CONTACT_COLOR,
  MARKER_LOST_CONTACT_TIMEOUT_COLOR,
  MARKER_MOVING_COLOR,
  MARKER_STATIONARY_COLOR,
} from '@/feature/observatory'

/**
 * Asset marker colours.
 *
 * These are deliberately fixed rather than read from the org's `mapMarkerColours` flag:
 * the markers render a white glyph on the coloured pin, and a light configured colour
 * left that glyph invisible. Owning the palette keeps every marker legible.
 */
export const useMarkerColors = () => ({
  moving: MARKER_MOVING_COLOR,
  stationary: MARKER_STATIONARY_COLOR,
  lostContactAfterOfflineTimeout: MARKER_LOST_CONTACT_TIMEOUT_COLOR,
  lostContactDefault: MARKER_LOST_CONTACT_COLOR,
})
